import { INotificationMessage } from "@fl/shared/src/types/messages";
import { ArquivosAttributes } from "@fl/shared/src/types/models/suporte_fl/arquivos";
import {
  ITableDataAction,
  ITableDataColumns,
} from "@fl/shared/src/types/tables";
import moment from "moment";
import { useEffect, useState } from "react";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { IoCloudDownloadOutline, IoCloudDownloadSharp } from "react-icons/io5";
import { RiFileExcel2Line } from "react-icons/ri";
import TableData from "../../../components/tables";
import ApiFiles from "../../../services/suporte/auth/arquivos";
import ApiReports from "../../../services/suporte/auth/reports";
import { formatFileSize } from "../../../utils/stringsFormats";
import DefaultBasePage from "../../default/base";

const RelatoriosUsuariosPrivatePage = () => {
  const columnsTable: ITableDataColumns[] = [
    {
      pk: true,
      columnKey: "id_arquivo",
      alignText: "text-center",
      label: "ID",
    },
    {
      columnKey: "tipo",
      alignText: "text-center",
      label: "Tipo",
      render: (item: ArquivosAttributes) => {
        if (item.extensao.toLowerCase() === "xlsx") {
          return <RiFileExcel2Line size={20} title="Excel" />;
        } else {
          return <BsFileEarmarkPdf size={20} title="PDF" />;
        }
      },
    },
    {
      columnKey: "arquivo",
      alignText: "text-center",
      label: "Arquivo",
    },
    {
      columnKey: "descricao",
      alignText: "text-center",
      label: "Descrição",
    },
    {
      columnKey: "tamanho_arquivo",
      alignText: "text-center",
      label: "Tamanho",
      render: (item: ArquivosAttributes) => {
        return formatFileSize(item.tamanho_arquivo);
      },
    },
    {
      columnKey: "gerado",
      alignText: "text-center",
      label: "Gerado Em",
      render: (item: ArquivosAttributes) => {
        return moment(item.data_geracao).format("DD/MM/YYYY [às] HH:mm");
      },
      sortValue: (item: ArquivosAttributes) => {
        return moment(item.data_geracao).toDate();
      },
    },
    {
      columnKey: "{actions}",
      label: "Ação",
      action: true,
      actionColumnIcons: true,
      alignText: "text-center",
      actionButtons: (item: ArquivosAttributes) => {
        var buttons: ITableDataAction[] = [
          {
            label: `Download`,
            icon: <IoCloudDownloadOutline size={20} />,
            iconHover: <IoCloudDownloadSharp size={20} />,
            hover: true,
            action: async (i: ArquivosAttributes) => {
              const result = await new ApiFiles().download(
                "relatorios",
                item.id_arquivo || 0
              );

              const file = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const fileURL = URL.createObjectURL(file);

              const a = document.createElement("a");
              a.href = fileURL;
              a.download = item.arquivo;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(fileURL);
            },
          },
        ];

        return [...buttons];
      },
    },
  ];

  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState<INotificationMessage[]>([]);

  const [reports, setReports] = useState<ArquivosAttributes[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);

  useEffect(() => {
    loadData(currentPage, itemsPerPage);
  }, [currentPage, itemsPerPage]);

  const loadData = async (page: number, limit: number) => {
    setLoading(true);
    try {
      const result = await new ApiReports().user(page, limit);

      if (result.success) {
        setReports(result.data.items);
        setTotalPages(Math.ceil(result.data.totalItems / limit));
      }

      if (result.message) setMessages(result.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (newSize: number) => {
    setItemsPerPage(newSize);
    setCurrentPage(1); // volta para a primeira página
  };

  return (
    <DefaultBasePage
      title="Meus Relatórios"
      h3
      loading={loading}
      message={messages}
    >
      <TableData
        columns={columnsTable}
        data={reports}
        pagination={{
          currentPage,
          totalPages,
          onPageChange: handlePageChange,
          itemsPerPage,
          onItemsPerPageChange: handleItemsPerPageChange,
          size: "sm",
        }}
      />
    </DefaultBasePage>
  );
};

export default RelatoriosUsuariosPrivatePage;
